import dayjs from 'dayjs';
import ENVIRONMENT from '@/env';

export default class BlogItem {
  constructor(data) {
    this.slug = null;
    this.name = null;
    this.title = null;
    this.tags = '';
    this.authorName = null;
    this.authorSlug = null;
    this.imageUrl = null;
    this.date = null;
    this.text = null;
    this.quote = null;
    this.smallTitle = null;

    // Initialize data
    if (data) {
      const tags = data.TagList.map((item) => item.TagName)
        .join(' | ')
        .toUpperCase();

      Object.assign(this, {
        slug: data.Slug,
        name: data.Name,
        title: data.Title || null,
        tags: tags,
        authorName: data.AuthorName,
        authorSlug: data.AuthorSlug,
        imageUrl: data.ImageUrl
          ? this.getUrl(data.ImageUrl)
          : '/static/images/about-left.jpg',
        date: dayjs(data.Date)
          .format('DD MMMM YYYY')
          .toUpperCase(),
        text: this.parseText(data.Text),
        quote: data.Quote,
        smallTitle: data.SmallTitle
      });
    }
  }

  getUrl = (data) => `${ENVIRONMENT.baseUrl + data}`;

  parseText = (text) => text.split('src="/media/').join(`src="${ENVIRONMENT.baseUrl}/media/`);
}



// WEBPACK FOOTER //
// src/entities/blog/blog-item.js